import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PharmGKBInternal from "../../../../components/PharmGKB/PharmGKBInternal";
import { displayVarsomePremiumDatabase } from "../../../../common/helpers/helpers";
import { getPharmGKBVariantData } from "../../../../state/selectors/PharmGKB.selectors";
import { getNotSubscribedSources } from "../../../../state/selectors/general.selectors";

const PharmGKB = (props) => {
  const { result, sources } = props;
  const displayPremiumDB = displayVarsomePremiumDatabase("pharmgkb", sources);
  if (result === null) return null;
  return (
    <div className="varsome-result-fixed" data-testid="pharmgkb-component">
      <div className="varsome-container varsome-container__basic">
        <PharmGKBInternal result={result} displayDatabase={displayPremiumDB} />
      </div>
    </div>
  );
};

PharmGKB.propTypes = {
  result: PropTypes.shape({}),
  sources: PropTypes.shape({}),
};

PharmGKB.defaultProps = {
  result: null,
  sources: null,
};

const mapStateToProps = (state) => ({
  result: getPharmGKBVariantData(state),
  sources: getNotSubscribedSources(state),
});

export default connect(mapStateToProps, {})(PharmGKB);
